/**
 * WordPress Dependencies
 */
const { __ } = wp.i18n;
const { addFilter } = wp.hooks;
const { Fragment } = wp.element;
const { InspectorAdvancedControls } = wp.blockEditor;
const { createHigherOrderComponent } = wp.compose;
const { ToggleControl } = wp.components;

/**
 * Add Attribute
 */
function lutherAddAttributesVisibleOnFrontend(settings) {
  if (typeof settings.attributes !== "undefined") {
    settings.attributes = Object.assign(settings.attributes, {
      visibleOnFrontend: {
        type: "boolean",
        default: true,
      },
    });
  }

  return settings;
}
addFilter(
  "blocks.registerBlockType",
  "luther/filter-visible-on-frontend-add-attribute",
  lutherAddAttributesVisibleOnFrontend
);

/**
 * Add mobile visibility controls on Advanced Block Panel.
 *
 * @param {function} BlockEdit Block edit component.
 *
 * @return {function} BlockEdit Modified block edit component.
 */
const withAdvancedControlsVisibilityFrontend = createHigherOrderComponent(
  (BlockEdit) => {
    return (props) => {
      const { attributes, setAttributes, isSelected } = props;

      const { visibleOnFrontend } = attributes;

      const IGNORED_BLOCKS = [
        "core/button",
        "core/column",
        "luther/accordion-container-content",
        "luther/accordion-container-title",
        "luther/content-carousel-inner",
        "luther/tabs-container-button",
        "luther/tabs-button",
        "luther/tabs-container-content",
        "luther/tabs-content",
      ];
      if (IGNORED_BLOCKS.includes(props.name)) {
        return (
          <Fragment>
            <BlockEdit {...props} />
          </Fragment>
        );
      }

      return (
        <Fragment>
          <BlockEdit {...props} />
          {isSelected && (
            <InspectorAdvancedControls>
              <ToggleControl
                label={__("Visible", "luther-core-functions")}
                checked={!!visibleOnFrontend}
                onChange={() =>
                  setAttributes({ visibleOnFrontend: !visibleOnFrontend })
                }
                help={
                  !!visibleOnFrontend
                    ? __(
                        "The element is visible in the front end",
                        "luther-core-functions"
                      )
                    : __(
                        "The element is not visible in the front end",
                        "luther-core-functions"
                      )
                }
              />
            </InspectorAdvancedControls>
          )}
        </Fragment>
      );
    };
  },
  "withAdvancedControls"
);

addFilter(
  "editor.BlockEdit",
  "luther/filter-visible-on-frontend-custom-toggle",
  withAdvancedControlsVisibilityFrontend
);

/**
 * Add ClassName
 */
const withStyleClasses = createHigherOrderComponent((BlockListBlock) => {
  return (props) => {
    const { visibleOnFrontend } = props.attributes;

    if (typeof visibleOnFrontend == "undefined" || visibleOnFrontend == true) {
      return <BlockListBlock {...props} />;
    }

    const { myAttribute } = props.attributes;

    return <BlockListBlock {...props} className={"frontend-hidden"} />;
  };
}, "withStyleClasses");

wp.hooks.addFilter(
  "editor.BlockListBlock",
  "luther/filter-visible-on-frontend-add-class",
  withStyleClasses
);
